import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { AppConstants } from "../Constant/app-constants";
import { ChartDetails } from '../Interfaces/chart-details';
import { ChartSelectionConstant } from "../Constant-Custom/chart-selection-constants";

@Injectable({
  providedIn: 'root'
})

export class UserSelectionsService {
  private storageKey = 'selectedChartDetails';
  selectedChartDetails: ChartDetails = {//initialize selectedChartDetails object with blank values
    chartCategory: "",
    displayName: "",
    routePath: "",
    routePath2: "",
    selectedChartTitle: "",
    description: [],
    chartFolderPath:"",
    chartFolderPath2:"",
    imgClassName:"",
    chartId: 1,
    ChartOutput: ""
  };

  constructor(){
    // Retrieve stored data on service initialization
    const storedData = sessionStorage.getItem(this.storageKey);
    if (storedData) {
      this.selectedChartDetails = JSON.parse(storedData);
    }
  }

  updateUserSelections(selectionObj: any) {
    this.selectedChartDetails = _.extend(this.selectedChartDetails, selectionObj);//update the selectedChartDetails with the selectionObj
    // Store the updated data in sessionStorage
    sessionStorage.setItem(this.storageKey, JSON.stringify(this.selectedChartDetails));
  }
  updateUserSelectionsChartDetails(selectionObj: any) {
    this.selectedChartDetails = _.extend(this.selectedChartDetails, selectionObj);//update the selectedChartDetails with the selectionObj
  }

  getUserSelections(): ChartDetails {
    return this.selectedChartDetails;//return selectedChartDetails variable
  }


  //returns the list of charts available for the selected chart type
  getAvailableChartSelectionBasedOnChartCategory(): any {
    switch (this.selectedChartDetails.chartCategory) {
      case AppConstants.barChartCategoryPathMap.chartCategory: return ChartSelectionConstant["barChartTypes"];
      case AppConstants.stackedBarChartCategoryPathMap.chartCategory: return ChartSelectionConstant["stackedBarChartTypes"];
      // case AppConstants.pyramidChartCategoryPathMap.chartCategory: return ChartSelectionConstant["pyramidChartTypes"];
      // case AppConstants.donutChartCategoryPathMap.chartCategory: return ChartSelectionConstant["donutChartTypes"];
      // case AppConstants.fillCategoryPathMap.chartCategory: return ChartSelectionConstant["fillChartTypes"];
      case AppConstants.lineOrTrendCategoryPathMap.chartCategory: return ChartSelectionConstant["lineOrTrendChartTypes"];
      // case AppConstants.vennDiagramCategoryPathMap.chartCategory: return ChartSelectionConstant["vennDiagramChartTypes"];
      case AppConstants.speedometerCategoryPathMap.chartCategory: return ChartSelectionConstant["speedometerChartTypes"];
      case AppConstants.pieCategoryPathMap.chartCategory: return ChartSelectionConstant["pieChartTypes"];
      case AppConstants.areaCategoryPathMap.chartCategory: return ChartSelectionConstant["areaChartTypes"];
      case AppConstants.scatterCategoryPathMap.chartCategory: return ChartSelectionConstant["scatterChartTypes"];
      case AppConstants.lollipopChartCategoryPathMap.chartCategory: return ChartSelectionConstant["lollipopChartTypes"];
      case AppConstants.spiderCategoryPathMap.chartCategory: return ChartSelectionConstant["spiderChartTypes"];
      case AppConstants.uniqueCategoryPathMap1.chartCategory: return ChartSelectionConstant["uniqueChartTypes1"];
      case AppConstants.uniqueCategoryPathMap2.chartCategory: return ChartSelectionConstant["uniqueChartTypes2"];
      case AppConstants.TableCategoryPathMap.chartCategory: return ChartSelectionConstant["TableChartTypes"];
       //case AppConstants.combinationCategoryPathMap.chartCategory: return ChartSelectionConstant["combinationChartTypes"];
      // case AppConstants.boxPlotSeriesCategoryPathMap.chartCategory: return ChartSelectionConstant["boxPlotSeriesChartTypes"];
      default: return ChartSelectionConstant["barChartTypes"];
    }
  }
}
